import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import { quizAnswersExportApi } from '~/apis/quiz-answers-export';
import {
  DOWNLOAD_QUIZ_ANSWERS_EXPORT_FILE,
  GET_CURRENT_QUIZ_ANSWERS_EXPORT,
  START_QUIZ_ANSWERS_EXPORT,
} from '~/utils/constants/actionType';
import { IBaseErrorData } from '~/utils/interface/base';
import {
  IBodyStartQuizAnswersExport,
  IPayloadDownloadQuizAnswersExportFile,
} from '~/utils/interface/quizAnswersExport';

export const startQuizAnswersExport = createAsyncThunk(
  START_QUIZ_ANSWERS_EXPORT,
  async (payload: IBodyStartQuizAnswersExport, { rejectWithValue }) => {
    try {
      const res = await quizAnswersExportApi.startQuizAnswersExport(payload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurrentQuizAnswersExport = createAsyncThunk(
  GET_CURRENT_QUIZ_ANSWERS_EXPORT,
  async (_payload: void, { rejectWithValue }) => {
    try {
      const res = await quizAnswersExportApi.getCurrentQuizAnswersExport();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/** Saves the file through a temporary link, so the Blob never goes into the store. */
export const downloadQuizAnswersExportFile = createAsyncThunk(
  DOWNLOAD_QUIZ_ANSWERS_EXPORT_FILE,
  async (payload: IPayloadDownloadQuizAnswersExportFile, { rejectWithValue }) => {
    try {
      const res = await quizAnswersExportApi.downloadQuizAnswersExportFile(payload.jobId);

      const url = URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = payload.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1000);

      return payload.fileName;
    } catch (error) {
      // The error body of a blob request is a Blob too: read it to get the business code.
      if (isAxiosError(error) && error.response?.data instanceof Blob) {
        try {
          const data: IBaseErrorData = JSON.parse(await error.response.data.text());
          return rejectWithValue(data);
        } catch {
          // Not JSON (e.g. a proxy error page).
        }
      }
      return rejectWithValue(error);
    }
  }
);
